module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/linescape-more-data-anniversary/linescape-more-data-anniversary.component.scss
// module id = 825
// module chunks = 0